import Utils from './Utils';
import { revendaApi } from "@/api/axios";

export default
{
    mixins: [Utils],
    components: {
        echart: () => import('../../../components/charts/BarChart')
    },
    props: {
        salers: Array,
        companies: Array,
        activities: Array,
    },
    data () {
        return {
            config: {
                periodRange: 13,
                monthLabel: ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"],
                monthRange: [],
                companiesNumberPerPage: 50
            },
            filters: {
                companyId: 0,
                salerId: 0
            },
            chart: {
                options: {
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '3%',
                        containLabel: true,
                        show:false
                    },
                    xAxis: {},
                    yAxis: {
                        value: 'category'
                    },
                    tooltip: {
                        type: 'shadow',
                        formatter:(params, ticket, callback)=>{
                            return `${params.name}: ${params.data.value} <br/> Receita: R$ ${this.formatMoney(params.data.profit)} <br/> Ticket Médio: R$ ${this.formatMoney(params.data.avgProfit)}`;
                        }
                    },
                    series:[]
                },
                metadata: {
                    loading: true
                }
            },
            table: {
                columns: [
                    {
                        title:'#',
                        key:'clienteId',
                        sortable:true,
                        width: 100
                    },
                    {
                        title:'Cliente',
                        key:'nome',
                        sortable:true,
                        minWidth: 250
                    },
                    {
                        title:'Cliente desde',
                        key:'cliente_desde',
                        sortable:true,
                        minWidth: 150,
                        render: (h, params) => {
                            return h('p', this.formatDate(params.row.cliente_desde))
                        }
                    },
                    {
                        title: 'Último Pagamento',
                        key: 'data_ultimo_pagamento',
                        sortable: true,
                        minWidth: 200,
                        render: (h, params) => {
                            return h('p', this.formatDate(params.row.data_ultimo_pagamento))
                        }
                    },
                    {
                        title: 'Próximo Vencimento',
                        key: 'proximo_vencimento',
                        sortable: true,
                        minWidth: 250,
                        render: (h, params) => {
                            return h('p', this.formatDate(params.row.proximo_vencimento))
                        }
                    },
                    {
                        title: 'Recorrência',
                        key: 'periodo',
                        sortable: true,
                        minWidth: 120
                    },
                    {
                        title: 'Vendedor',
                        key: 'vendedor_nome',
                        sortable: true,
                        minWidth: 200
                    },
                    {
                        title:'Valor pago no Mês',
                        key:'mensalidade_valor',
                        align: "right",
                        sortable:true,
                        minWidth: 150,
                        render:(h, params)=>{
                            return h('p',
                                this.formatMoney(params.row.mensalidade_valor)
                            )
                        }
                    }
                ],
                data: []
            },
            metadata: {
                status: String,
                showTable: false,
                loading: false,
                page: 0,
                companiesNumber: 0,
                companiesNumberLoaded: 0
            }
        }
    },
    methods: {
        /**
         * Abstract method. Do nothing here. It's a reponsibility of subcomponent that has extends this mixin.
         */
        loadChart()
        {

        },
        loadMoreCompanies: _.debounce(async function ({target})
        {
            let windowRelativeBottom = target.scrollHeight - target.offsetHeight;
            if ((target.scrollTop > windowRelativeBottom - 50) && !((this.metadata.page + 1) * 50 > this.metadata.companiesNumber)) {
                this.metadata.page++;
                await this.getMoreData();
                target.scrollTop = windowRelativeBottom;
            }
        }, 300),
        async getChart(chartName)
        {
            const {data} = await revendaApi.get('stats/companies/graph', {
                params: {
                    status: chartName, saler_id: this.filters.salerId, company_id: this.filters.companyId, activity_name: this.filters.activityName
                }
            });

            return data;
        },
        async getChartData (period, status, page) {
            const {data} = await revendaApi.get('stats/companies', {
                params: {
                    status: status, page: page, period: period, saler_id: this.filters.salerId,
                    company_id: this.filters.companyId
                }
            });
            return this.defaultingChartData(data);
        },
        async getMoreData()
        {
            this.metadata.loading = true;
            const data = await this.getChartData(this.metadata.period, this.metadata.status, this.metadata.page);
            this.metadata.loading = false;
            this.metadata.companiesNumberLoaded += data.length;
            this.table.data.push(...data);
        },
        defaultingChartData(data)
        {
            return data.map(value => (
                {
                    clienteId: value.id_pessoa,
                    nome: value.pessoa_nome,
                    cliente_desde: value.data_pessoa_cadastro,
                    data_ultimo_pagamento: value.ultimo_pagamento,
                    periodo: value.periodo_recorrencia,
                    mensalidade_valor: value.mensalidade_valor,
                    data_pagamento: value.data_lancamento,
                    vendedor_nome: value.vendedor_nome,
                    proximo_pagamento: value.proximo_pagamento,
                    proximo_vencimento:value.proximo_vencimento,
                    data_vencimento: value.data_vencimento,
                    data_vencimento_ultima_parcela_paga: value.data_vencimento_ultima_parcela_paga
                }))
        },
        defaultingChart(chartData) {
            let periods = [];
            for (let i=0; i <= this.config.periodRange; i++) {
                periods.push({name: i, value: 0, profit: 0, avgProfit: 0});
            }
            chartData = chartData.map(period => ({name: period.periodo, value: parseFloat(period.total), profit: parseFloat(period.receita_bruta), avgProfit: parseFloat(period.ticket_medio)}));
            for (let i = 0; i <= periods.length ; i++) {
                let dateMonth = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
                dateMonth.setMonth(dateMonth.getMonth() - i);

                let period = chartData.find(periodGraph => parseInt(periodGraph.name.split("-")[1] - 1) === dateMonth.getMonth() && parseInt(periodGraph.name.split("-")[0]) === dateMonth.getFullYear());
                if (period) {
                    periods[i] = period;
                }
            }

            return periods.reverse();
        },
        clearMetadata()
        {
            this.metadata.status = String,
            this.metadata.showTable = false,
            this.metadata.loading = false,
            this.metadata.page = 0,
            this.metadata.companiesNumber = 0,
            this.metadata.companiesNumberLoaded = 0
        },
        async getCustomersByStatus(params)
        {
            if (!params.selected) {
                this.$emit('showDownload', true);
                const name = params.data.name;
                const status = (this.chart.options.legend.data.find(lg => lg.name === params.seriesName).alias);
                this.metadata.period = name;
                this.metadata.status = status;
                this.metadata.showTable = true;
                this.metadata.loading = true;
                const data = await this.getChartData(name, status, 0);
                this.table.data = data;
                this.metadata.loading = false;
                this.metadata.companiesNumber = params.value;
                this.metadata.companiesNumberLoaded = data.length;
            } else {
                this.$emit('showDownload', false);
                this.metadata.showTable = false;
            }
        },

        chartTotalizer(firstSerie, secondSerie)
        {
            const totalizer = [];
            const collum1 = Object.values(firstSerie);
            const collum2 = Object.values(secondSerie);

            for (let i =0;i<=this.config.periodRange;i++) {
                totalizer[i] = {value:collum1[i].value + collum2[i].value, profit:collum1[i].profit + collum2[i].profit, avgProfit:(collum1[i].avgProfit + collum2[i].avgProfit)/2}
            }
            return totalizer;
        }
    },

    created()
    {
        this.loadPeriodRange();
        this.loadChart();
    }
}
